import type { PriceSensitivity } from './routeMetrics';
import { PRICE_RESISTANCE_LABEL } from './routeMetrics';
import { formatSignedPct } from './formatters';
import { InfoPopover } from '../common/InfoPopover';

interface PriceSensitivityIndicatorProps {
  readonly sensitivity: PriceSensitivity;
}

/**
 * Compact readout comparing a proposed fare against the market baseline and
 * estimating the demand response.
 */
export function PriceSensitivityIndicator({ sensitivity }: PriceSensitivityIndicatorProps) {
  const vsMarketPct = (sensitivity.fareRatioToMarket - 1) * 100;
  const tone = sensitivity.rating.toLowerCase();

  return (
    <div className="ri-sensitivity">
      <span className={`ri-chip ri-chip--${tone}`}>
        {PRICE_RESISTANCE_LABEL[sensitivity.rating]}
      </span>
      <InfoPopover topic="priceElasticity" />
      <span className="ri-sensitivity__detail">
        {formatSignedPct(vsMarketPct)} vs market
      </span>
      <span className="ri-sensitivity__detail">
        Est. demand {formatSignedPct(sensitivity.demandChangeVsCurrentPct)} vs current fare
      </span>
    </div>
  );
}
